/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import * as stacktraceParser from "stacktrace-parser";
import parseHermesStack from "./parseHermesStack";
function convertHermesStack(stack) {
    var frames = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stack.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (entry.type !== "FRAME") {
                continue;
            }
            var location = entry.location, functionName = entry.functionName;
            if (location.type === "NATIVE") {
                continue;
            }
            frames.push({
                methodName: functionName,
                file: location.sourceUrl,
                lineNumber: location.line1Based,
                column: location.type === "SOURCE" ? location.column1Based - 1 : location.virtualOffset0Based
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return frames;
}
function parseErrorStack(errorStack) {
    if (!errorStack) {
        return [];
    }
    var parsedStack = Array.isArray(errorStack) ? errorStack : global.HermesInternal ? convertHermesStack(parseHermesStack(errorStack)) : stacktraceParser.parse(errorStack).map(function(frame) {
        return _object_spread_props(_object_spread({}, frame), {
            column: frame.column != null ? frame.column - 1 : null
        });
    });
    return parsedStack;
}
export default parseErrorStack;
